import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

/**
 * Selects the user information from the root state.
 * @param {RootState} state - The root state of the Redux store.
 * @returns {Object} The user state slice.
 */
export const selectUserInfo = (state: RootState) => state.user;

/**
 * Selects the current user's ID from the user information.
 * This selector is memoized for performance optimization.
 * @type {Function}
 * @returns {string|null} The current user's ID, or null if not available.
 */
export const selectCurrentUserID = createSelector(
  [selectUserInfo],
  (user) => user.info.userID,
);

export const selectCurrentInfo = createSelector(
  [selectUserInfo],
  (user) => user.info,
);
